import React from 'react'
import { Link } from 'react-router-dom';

const Error = () => {
  return (
    <div className=" flex justify-center items-center  text-richblack-5 bg-richblack-900 min-h-[calc(100vh-3.5rem)]">
      <div className="  dark:bg-gray-900">
        <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
          <div className="mx-auto max-w-screen-sm text-center">
            <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">
              404
            </h1>
            <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
              Something's missing.
            </p>
            <p className="mb-8 text-lg font-light text-gray-500 dark:text-gray-400 ">
              Sorry, we can't find that page. You'll find lots to explore on the
              home page.{" "}
            </p>
            <Link
              to="/"
              className="yellowButton bg-yellow-50 text-richblack-900"
            >
              Back to Homepage
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Error